
import React from 'react';

const Checkbox = ({ label, checked, onChange }) => {
  return (
    <div className="checkbox">
      <label>
        <input type="checkbox" checked={checked} onChange={onChange} required />
        <span>{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;


